import type { LogRecord } from "../../api/client";
import type { Column } from "../grid/CompGrid";
import { CompGrid } from "../grid/CompGrid";
import { Panel } from "../layout/Panel";

export function TraceLogsGrid(props: {
  logs: LogRecord[];
  loading: boolean;
  error: string | null;
  columns: Column<LogRecord>[];
  hoveredSpanId: string | null;
}) {
  const { logs, loading, error, columns, hoveredSpanId } = props;

  return (
    <Panel title="Logs (this trace)" subtitle={`Grouped by service + span name.`}>
      <CompGrid
        items={logs}
        loading={loading}
        error={error}
        columns={columns}
        keyExtractor={(log) => log.log_id}
        emptyMessage="No logs found"
        isItemDimmed={(log) => {
          if (hoveredSpanId) return log.span_id !== hoveredSpanId;
          return false;
        }}
      />
    </Panel>
  );
}
